import React, { useCallback } from 'react';
import { ApolloError } from '@apollo/client';

import { snackbar } from '@occc-app/design-system';
import { useVerifyCsrotpSessionMutation, VerifyCsrotpSessionMutation } from '@occc/graphql';
import { getErrorMessage } from '@occc/utils';

import { EnterOTPCodeModal } from './enter-otp-code.modal';
import { EnterOTPFormProps } from './types';

const onError = (error: ApolloError) => {
  snackbar.error(error.message || 'Something went wrong. Please try again.');
};

type EnterOTPCodeModalContainerProps = {
  session?: string;
  isOpen: boolean;
  onHide: () => void;
  onCompleted: (value: VerifyCsrotpSessionMutation) => void;
};

export const EnterOTPCodeModalContainer = ({
  session,
  isOpen,
  onHide,
  onCompleted,
}: EnterOTPCodeModalContainerProps) => {
  const [verifyCSROTPSessionMutation, { loading }] = useVerifyCsrotpSessionMutation();
  const onSubmit: EnterOTPFormProps['onSubmit'] = useCallback(
    async ({ otp }) => {
      if (!session) {
        return;
      }

      const { errors } = await verifyCSROTPSessionMutation({
        variables: {
          otp: {
            otp,
            session,
          },
        },
        onCompleted,
        onError,
      });

      if (!errors) {
        return;
      }

      return {
        otp: getErrorMessage(errors),
      };
    },
    [onCompleted, session, verifyCSROTPSessionMutation],
  );

  return (
    <EnterOTPCodeModal isOpen={isOpen} onHide={onHide} onSubmit={onSubmit} isLoading={loading} />
  );
};
